export const reservedSlugs = [
	'login',
	'signup',
	'organization',
	'auth',

	// TODO: PR will follow to create a single route for all non-project routes (/$/)
	'account',
];
